import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export const badgeVariants = cva("inline-flex items-center gap-1 rounded-pill px-3 py-0.5 text-sm font-medium", {
  variants: {
    variant: {
      default: "bg-secondary-subtle text-secondary-subtle-fg",
      solid: "bg-secondary text-secondary-fg",
      outline: "border border-border-strong text-fg-muted",
      grey: "bg-surface-muted text-fg-muted",
      success: "bg-success-subtle text-success-fg",
      warning: "bg-warning-subtle text-warning-fg",
      danger: "bg-danger-subtle text-danger-fg",
      info: "bg-info-subtle text-info-fg",
    },
  },
  defaultVariants: { variant: "default" },
});

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
